import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton } from '@material-ui/core';
import CreateIcon from '@material-ui/icons/Create';
import React from 'react';
import '../sticky-recap.scss';
import { Markup } from 'interweave';

interface IQuestionProps {
    index: number;
    title?: string;
    response?: string;
    showIndex?: boolean;
    focusStepToUpdate?: (stepKey) => void;
    children?: React.ReactNode;
}

const Question = (props: IQuestionProps) => {
    const { index, showIndex, title, response } = props || {};

    const renderResponse = (res: string) => {
        if (!res) return null; // Évite d'afficher un contenu vide
        
        return /<[a-z][\s\S]*>/i.test(res) ? (
            <Markup noWrap content={res} />
        ) : (
            res
        );
    };

    return (
        <div className='question' key={index}
            onClick={() => {
                props?.focusStepToUpdate(index);
            }}>
            <div className='recap-question-check'>
                {showIndex ?
                    <div className='question-index'>
                        {index + 1}
                    </div>
                    :
                    <div className='question-answered'>
                        <FontAwesomeIcon color='white' icon={faCheck} className="fa-check" />
                    </div>
                }
            </div>
            <div className='recap-question-res'>
                <div className='recap-question-title'>
                    {title}
                </div>
                <div className='recap-question-response'>
                    {renderResponse(response)}
                </div>
            </div>
            <div className="recap-question-action">
                <IconButton
                    className="btn-edit-sticky-recap"
                    aria-label="Modifier">
                    <CreateIcon />
                </IconButton>
            </div>
        </div>
    );
}
export default Question;